<template>
  <div class="container-custom" v-if="support != null">
    <!-- BreadScrumbs -->
    <BreadScrumbs
      :links="[
        { name: 'Support Page', to: { path: '/support-page' } },
        { name: 'Edit', to: { path: '/support-page/edit' } },
      ]"
    ></BreadScrumbs>
    <!-- page-actions -->
    <div class="page-actions">
      <h2>編輯 Support Page</h2>
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>

    <!-- block1 -->
    <div class="block mb-5">
      <!-- BU Name -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>BU Name</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex align-center">
          <div class="form-input-group">
            <input type="text " class="mr-10px w-248px" disabled :value="support.name" />
          </div>
          <div class="h5 ink-02-medium--text">
            (當BU Page建立時，將自動生成Support Page，不可於此編輯BU Name)
          </div>
        </div>
      </div>
      <!-- Sections -->
      <div class="form-item d-flex py-5">
        <div class="w-240px mr-5">
          <h4>Sections</h4>
        </div>
        <div class="flex-grow-1 flex-basis-0">
          <v-radio-group v-model="support.support_type">
            <!-- B2B section options -->
            <div>
              <div class="mb-5">
                <v-radio value="b2b">
                  <template v-slot:label>
                    <div class="h5 ink-01-emphasis--text">
                      B2B
                    </div>
                  </template></v-radio>
              </div>
              <div v-if="support.support_type === 'b2b'" class="ml-7">
                <div class="d-flex flex-wrap">
                  <div
                    v-for="section in sectionsOfB2B"
                    :key="section.name"
                    class="w-220px mb-2"
                  >
                    <v-checkbox v-model="section.isChecked">
                      <template v-slot:label>
                        <div class="h5 ink-01-emphasis--text">
                          {{ section.name }}
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
              </div>
            </div>
            <!-- B2C section options -->
            <div>
              <div class="mb-5">
                <v-radio value="b2c">
                  <template v-slot:label>
                    <div class="h5 ink-01-emphasis--text">
                      B2C
                    </div>
                  </template></v-radio>
              </div>
              <div v-if="support.support_type === 'b2c'" class="ml-7">
                <div class="d-flex flex-wrap">
                  <div
                    v-for="section in sectionsOfB2C"
                    :key="section.name"
                    class="w-220px mb-2"
                  >
                    <v-checkbox v-model="section.isChecked">
                      <template v-slot:label>
                        <div class="h5 ink-01-emphasis--text">
                          {{ section.name }}
                        </div>
                      </template>
                    </v-checkbox>
                  </div>
                </div>
              </div>
            </div>
          </v-radio-group>
        </div>
      </div>
      <!-- BU Name -->
      <div class="pa-5 d-flex">
        <div class="w-240px mr-5">
          <h4>是否開啟Tab</h4>
          <div class="h5 ink-02-medium--text">
            包含線上報修、產品註冊、維修進度查詢
          </div>
        </div>
        <div class="flex-grow-1 flex-basis-0 my-n2 d-flex align-center">
          <FormSwitch v-model="support.has_other_page"></FormSwitch>
        </div>
      </div>
    </div>

    <!-- block2 -->
    <div class="block">
      <div v-if="isCheckedSectionsOfB2B.length > 0 && support.support_type == 'b2b'">
        <PageMenu :sections="isCheckedSectionsOfB2B">
          <component :is="filterSectonsViewOfB2B" :support="support"></component>
        </PageMenu>
      </div>
      <div v-if="isCheckedSectionsOfB2C.length > 0 && support.support_type == 'b2c'">
        <PageMenu :sections="isCheckedSectionsOfB2C">
          <component :is="filterSectonsViewOfB2C" :support="support"></component>
        </PageMenu>
      </div>
    </div>

    <!-- alert info -->
    <div class="d-flex mt-5" v-if="filterSectonsViewOfB2C === 'B2CAfterSalesService'">
      <!-- content head -->
      <div class="w-300px mr-5">
        <h3 class="mb-10px">Alert Info</h3>
        <div class="h4">
          Pop-Up彈出視窗資訊內容
        </div>
      </div>
      <div class="flex-grow-1">
        <!-- content body -->
        <div class="block mb-5">
          <!-- Title -->
          <label class="form-item d-flex pt-5">
            <h4 class="w-160px mr-5">Title</h4>
            <div class="my-n2 flex-grow-1">
              <v-text-field
                v-model="support.service_alert_title"
                outlined
                dense
              ></v-text-field>
            </div>
          </label>
          <!-- Description -->
          <label class="form-item d-flex py-5">
            <h4 class="w-160px mr-5">Description</h4>
            <div class="my-n2 flex-grow-1">
              <editor
                v-model="support.service_alert_content"
                :plugins="'link'"
                :toolbar="'link'"
              />
            </div>
          </label>

          <!-- Start Date -->
          <label class="form-item d-flex pt-5">
            <div class="w-160px mr-5"><h4>設定開啟日期</h4></div>
            <div class="my-n2 flex-grow-1">
              <v-menu
                v-model="alertStartMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="support.service_alert_start"
                    placeholder="請選擇日期"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>

                </template>
                <v-date-picker
                  v-model="support.service_alert_start"
                  @input="alertStartMenu = false"
                >
                  <v-btn text color="primary" @click="support.service_alert_start = null">重設</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </label>

          <!-- Start Date -->
          <label class="form-item d-flex pt-5">
            <div class="w-160px mr-5"><h4>設定關閉日期</h4></div>
            <div class="my-n2 flex-grow-1">
              <v-menu
                v-model="alertEndMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="support.service_alert_end"
                    placeholder="請選擇日期"
                    outlined
                    dense
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="support.service_alert_end"
                  @input="alertEndMenu = false"
                >
                  <v-btn text color="primary" @click="support.service_alert_end = null">重設</v-btn>
                </v-date-picker>
              </v-menu>
            </div>
          </label>
        </div>
      </div>
    </div>

    <!-- page-actions -->
    <div class="page-actions">
      <v-spacer></v-spacer>
      <button class="btn mr-5" @click="cancelHandler">取消</button>
      <button class="btn btn-primary" @click="saveHandler">儲存</button>
    </div>
    <LangDialog :isOpen.sync="isLangOpen" @confirm-submit="saveHandler()"></LangDialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import BreadScrumbs from '@/components/Breadscrumbs.vue';
import PageMenu from '@/components/PageMenu.vue';
import LangDialog from '@/components/LangSubmitDialog.vue';
import Editor from '@/components/TinymceEditor.vue';
import FormSwitch from '@/components/FormSwitch.vue';

// B2B
import B2BWarrantyPolicy from '@/views/G_Support/c/G-1-1a-2__SupportEdit_B2B_Warranty Policy.vue';
import B2BPcnEolPolicy from '@/views/G_Support/c/G-1-1a-3__SupportEdit_B2B_PCN & EOL Policy.vue';
import B2BFAQ from '@/views/G_Support/c/G-1-1a-4__SupportEdit_B2B_FAQ.vue';
import B2BDownloads from '@/views/G_Support/c/G-1-1a-5__SupportEdit_B2B_Downloads.vue';
import B2BAfterSalesService from '@/views/G_Support/c/G-1-1b-2__SupportEdit_B2B_AfterSalesService.vue';

// B2C
import B2CDownloads from '@/views/G_Support/c/G-1-1b-1__SupportEdit_B2C_Downloads.vue';
import B2CAfterSalesService from '@/views/G_Support/c/G-1-1b-2__SupportEdit_B2C_AfterSalesService.vue';
import B2CWarrantyPolicy from '@/views/G_Support/c/G-1-1b-3__SupportEdit_B2C_WarrantyPolicy.vue';
import B2CFAQ from '@/views/G_Support/c/G-1-1b-4__SupportEdit_B2C_FAQ.vue';
import EmptyLayout from '@/components/Layouts/EmptyLayout.vue';
import B2CTechnicalSupports from '@/views/G_Support/c/G-1-1b-5__SupportEdit_B2C_TechnicalSupports.vue';
import B2CAntiForgery from '@/views/G_Support/c/G-1-1b-7__SupportEdit_B2C_Anti-forgery.vue';

export default {
  components: {
    BreadScrumbs,
    PageMenu,
    LangDialog,
    Editor,
    FormSwitch,
    // B2B
    B2BWarrantyPolicy,
    B2BPcnEolPolicy,
    B2BFAQ,
    B2BDownloads,
    B2BAfterSalesService,
    // B2C
    B2CDownloads,
    B2CAfterSalesService,
    B2CWarrantyPolicy,
    B2CFAQ,
    EmptyLayout,
    B2CTechnicalSupports,
    B2CAntiForgery,
  },
  data() {
    return {
      isLangOpen: false,
      alertStartMenu: false,
      alertEndMenu: false,
      sectionsOfB2B: [],
      sectionsOfB2C: [],
    };
  },
  async created() {
    if (this.$route.params.id && this.support === null) {
      await this.getBuSupport(this.$route.params.id);
    }
    await this.getSections().then((data) => {
      this.sectionsOfB2B = data.filter(
        (item) => {
          item.name = item.title;
          if (this.support.sections) {
            item.isChecked = this.support.sections.indexOf(item.id) !== -1;
          }
          return item.b2b;
        },
      );
      this.sectionsOfB2C = data.filter(
        (item) => {
          item.name = item.title;
          if (this.support.sections) {
            item.isChecked = this.support.sections.indexOf(item.id) !== -1;
          }
          return item.b2c;
        },
      );
    });
  },
  computed: {
    ...mapState(['lang']),
    ...mapState('support', ['support']),
    sectionIndex() {
      return this.$route.query.section || 0;
    },
    sectionViewOfB2B() {
      return this.sectionsOfB2B[this.sectionIndex].component;
    },
    isCheckedSectionsOfB2B() {
      return this.sectionsOfB2B.filter((section) => section.isChecked);
    },
    filterSectonsViewOfB2B() {
      // avoid active not checked section view
      // ex: unchecked QuickTips checkbox, section QuickTips should disappear
      if (
        this.isCheckedSectionsOfB2B.length === Number(this.sectionIndex) &&
        this.support.support_type === 'b2b'
      ) {
        this.$router.replace({ query: { section: '0' } });
      }

      return this.isCheckedSectionsOfB2B[this.sectionIndex].component;
    },
    // B2C
    sectionViewOfB2C() {
      return this.sectionsOfB2C[this.sectionIndex].component;
    },
    isCheckedSectionsOfB2C() {
      return this.sectionsOfB2C.filter((section) => section.isChecked);
    },
    filterSectonsViewOfB2C() {
      // avoid active not checked section view
      // ex: unchecked QuickTips checkbox, section QuickTips should disappear
      if (
        this.isCheckedSectionsOfB2C.length === Number(this.sectionIndex) &&
        this.support.support_type === 'b2c'
      ) {
        this.$router.replace({ query: { section: '0' } });
      }
      const view = this.isCheckedSectionsOfB2C[this.sectionIndex];

      return view ? view.component : null;
    },
    isCheckedSectionData() {
      const sections = this.support.support_type === 'b2b'
        ? this.isCheckedSectionsOfB2B
        : this.isCheckedSectionsOfB2C;
      return sections.filter((section) => section.isChecked).map((section) => section.id);
    },
  },
  watch: {
    'support.support_type'() {
      this.$router.replace({ query: { section: '0' } });
    },
  },
  methods: {
    ...mapActions('support', {
      getSections: 'sections',
      getBuSupport: 'findById',
      save: 'save',
      clear: 'clear',
    }),
    cancelHandler() {
      this.$router.push('/support-page');
    },
    saveHandler() {
      if (this.isLangOpen || !this.lang.id) {
        this.support.sections = this.isCheckedSectionData;
        this.save(this.support).then(() => {
          this.$router.push({ name: 'Support' });
          this.clear();
        });
      } else {
        this.isLangOpen = true;
      }
    },
  },
  beforeMount() {
    if (this.support !== null &&
        this.support.support_type === 'b2b' &&
        this.sectionIndex >= 5) {
      this.$router.replace({ query: { section: '0' } });
    }
  },
};
</script>

<style></style>
